import { createAsyncThunk } from '@reduxjs/toolkit';
import { AsyncOperationHandler } from '../../../helpers/redux-helpers';

export const getBuildings = createAsyncThunk('buildings/getBuildings', (siteId: string) => {
	return AsyncOperationHandler(client => client.buildings_GetBySiteId(siteId));
});
